import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { memo } from 'react'
import BaseMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import * as markdownStyles from './Markdown.css'
import { RetrievedImage } from './types'

export const Markdown = memo(function Markdown(props: { message: string; images?: RetrievedImage[] }) {
  const consumedImages = new Set<number>()
  const replacedMessage = props.message?.replaceAll(/ ?\[[^\]]+?\d+\].?/g, (match) => {
    const hasDot = match.endsWith('.')
    const num = match.slice(1, hasDot ? -2 : -1)
    // Remove anything other than numbers
    const cleanedNum = num.replace(/\D/g, '')
    const position = parseInt(cleanedNum, 10)
    console.log('position', position)
    if (consumedImages.has(position)) {
      // Ensure the same image is not used multiple times
      console.log('already consumed', position)
      return ''
    }
    const image = props.images?.find((img) => img.position === position)
    if (image) {
      consumedImages.add(position)
      return `${hasDot ? '.' : ''}![${image.name}](${image.url})`
    }
    return match
  })

  return (
    <BaseMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        table: ({ node, ...props }) => (
          <table
            className={markdownStyles.table}
            {...props}
          />
        ),
        ol: ({ node, ref, ...props }) => (
          <Box
            component="ol"
            sx={{ listStyleType: 'decimal', pl: 2, my: 1 }}
            {...props}
          />
        ),
        ul: ({ node, ref, ...props }) => (
          <Box
            component="ul"
            sx={{ listStyleType: 'disc', pl: 2, my: 1 }}
            {...props}
          />
        ),
        li: ({ node, ref, ...props }) => <li {...props} />,
        h1: ({ node, ref, ...props }) => (
          <Typography
            variant="h1"
            component="h1"
            {...props}
          />
        ),
        h2: ({ node, ref, ...props }) => (
          <Typography
            variant="h2"
            component="h2"
            {...props}
          />
        ),
        h3: ({ node, ref, ...props }) => (
          <Typography
            variant="h3"
            component="h3"
            {...props}
          />
        ),
        h4: ({ node, ref, ...props }) => (
          <Typography
            variant="h4"
            component="h4"
            {...props}
          />
        ),
        p: ({ node, ref, ...props }) => (
          <Typography
            variant="body2"
            component="p"
            {...props}
          />
        ),
        strong: ({ node, ref, ...props }) => (
          <Typography
            component="span"
            fontWeight="bold"
            {...props}
          />
        ),
        a: ({ node, ref, ...props }) => {
          return (
            <Link
              target="_blank"
              rel="noopener noreferrer"
              {...props}
              href={props.href?.startsWith('http') ? props.href : `https://${props.href}`}
            />
          )
        },
        img: ({ node, ref, ...props }) => (
          <img
            {...props}
            style={{ maxWidth: '100%', display: 'block', marginTop: 8, marginBottom: 8 }}
            alt={props.alt}
          />
        ),
      }}
    >
      {replacedMessage}
    </BaseMarkdown>
  )
})
